import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusColor } from '../../../constants/status.constants';
import { ClassNames } from '../../../constants/class-names.constants';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-status-pill-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                [ngClass]="[
                    column.sortable !== false ? classNames.Sortable : 'not-sortable',
                    !!column.headerPopoverContent ? classNames.ThWithPopover : '',
                    column.className || ''
                ]"
                [ngStyle]="{ width: column.width || 'auto' }"
                (click)="changeSort()"
            >
                <div class="th-content">
                    <ng-container *ngIf="column.headerPopoverContent">
                        <popover-content
                            #headerPopover
                            [size]="column.headerPopoverSize || 'small'"
                        >
                            {{ column.headerPopoverContent }}
                        </popover-content>
                        <div
                            [popover]="headerPopover"
                            [popoverPlacement]="getHeaderPopoverPlacement()"
                        >
                            <span [innerHtml]="column.header"></span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!column.headerPopoverContent">
                        <span [innerHtml]="column.header"></span>
                    </ng-container>

                    <div *ngIf="isSortable$ | async">
                        <lsq-icon
                            class="sort-caret"
                            [ngClass]="{ 'is-sorted': isCurrentlySorted() }"
                            [type]="getIconType()"
                            [color]="getIconColor()"
                        >
                        </lsq-icon>
                    </div>
                </div>
            </th>

            <td
                cdk-cell
                *cdkCellDef="let row"
                [ngStyle]="{ width: column.width || 'auto' }"
                [ngClass]="[
                    column.sortable !== false ? classNames.Sortable : 'not-sortable',
                    column.className || ''
                ]"
            >
                <status-pill
                    [status]="row[column.key]"
                    [displayValueMap]="displayValueMap"
                    [width]="pillWidth"
                ></status-pill>
            </td>

            <td
                cdk-footer-cell
                *cdkFooterCellDef
                [ngStyle]="{ width: column.width || 'auto' }"
                [ngClass]="[
                    column.sortable !== false ? classNames.Sortable : 'not-sortable',
                    column.className || ''
                ]"
            >
                <!-- Custom Column Cell Footer -->
                <div *ngFor="let customFooter of customColumnFooters">
                    <ng-container
                        *ngTemplateOutlet="customFooter.templateRef; context: { row: row }"
                    ></ng-container>
                </div>
            </td>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LsqStatusPillColumnComponent extends LsqBaseColumnComponent {
    @Input() public displayValueMap: any;
    @Input() public pillWidth?: string;

    public classNames = ClassNames;
    public statusColor = StatusColor;
}
